module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAK9JREFUKFONkjEOwjAUQ+0cJB3ShXbmPiAYkDgPggEK50GsdCpD4R75KECqKA2Qv0WJX2zrU5v6QuLcd9c1AEHesCjrjYidUptqC2AlRPPo2mUGRBVltRfBHMCOAJQ21QHALAMSik/3W7twADc5kJEYgPWAf5Ck2IlCwDcIfWYSx/7dk/Vdx4ARRAF0haXEKQcePHTyepT4+ZeDADJpSNrYdrgqqQjhvfochszxnj0BV85mRM0u+N8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt.png
// module id = DmtO
// module chunks = 1